import _extends from "@babel/runtime/helpers/esm/extends";
const cherryPickKeys = keys => source => {
  return keys.reduce((obj, key) => _extends({}, obj, {
    [key]: source[key]
  }), {});
};
export default cherryPickKeys;